import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  input,
  InputSignal,
  OnInit,
  output,
  OutputEmitterRef,
  signal,
  WritableSignal
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { IonicModule } from '@ionic/angular';
import { debounceTime, Subject } from 'rxjs';

@Component({
  selector: 'lib-days-range-slider',
  templateUrl: './days-range-slider.component.html',
  styleUrls: ['./days-range-slider.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [IonicModule]
})
export class DaysRangeSliderComponent implements OnInit {
  private readonly destroyRef: DestroyRef = inject(DestroyRef);
  private readonly input$: Subject<number> = new Subject<number>();

  readonly min: InputSignal<number> = input<number>(1);
  readonly max: InputSignal<number> = input<number>(30);
  readonly value: InputSignal<number> = input<number>(7);
  readonly debounce: InputSignal<number> = input<number>(1500);
  readonly valueChange: OutputEmitterRef<number> = output<number>();

  readonly displayValue: WritableSignal<number> = signal<number>(0);

  ngOnInit(): void {
    this.displayValue.set(this.value());

    this.input$.pipe(debounceTime(this.debounce()), takeUntilDestroyed(this.destroyRef)).subscribe((value: number) => {
      this.valueChange.emit(value);
    });
  }

  onInput(event: Event): void {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const value: number = (event as any).detail.value;
    this.displayValue.set(value);
    this.input$.next(value);
  }
}
